<template>

	<div>

		<!-- content -->
		<div class="content learning">
			<div class="container">

				<edu-learning v-if="mode === 'learn' && emIdx > 0" @goList="goList"></edu-learning>


				<template v-if="mode === '' || mode === 'list' ">

					<!-- 페이지 타이틀 -->
					<div class="page-title">
						<h2 class="tit">{{ PAGE_TITLE }}</h2>
					</div>


					<!-- 리스트 옵션 -->
					<div class="list-controls">
						<form @submit.prevent="doSearch">

							<!-- 탭 -->
							<div class="tab swiper-container m-b-10" v-if="$options.filters.isEmpty( params.WISH_LIKE )">
								<ul class="swiper-wrapper">
									<li class="swiper-slide" :class="{ 'active': (params.STATUS === 'all') }">
										<a href="javascript:;" @click="setStatus('all')">전체</a>
									</li>
									<li class="swiper-slide" :class="{ 'active': (params.STATUS === 'req') }">
										<a href="javascript:;" @click="setStatus('req')">학습중</a>
									</li>
									<li class="swiper-slide" :class="{ 'active': (params.STATUS === 'com') }">
										<a href="javascript:;" @click="setStatus('com')">학습완료</a>
									</li>
								</ul>
							</div>

<!--							<div class="tab swiper-container m-b-10" v-if="!$options.filters.isEmpty( params.WISH_LIKE )">-->
<!--								<ul class="swiper-wrapper">-->
<!--									<li class="swiper-slide" :class="{ 'active': (params.STATUS === 'edu') }">-->
<!--										<a href="javascript:;" @click="setStatus('edu')">교육</a>-->
<!--									</li>-->
<!--									<li class="swiper-slide" :class="{ 'active': (params.STATUS === 'board') }">-->
<!--										<a href="" @click="setStatus('board')">게시글</a>-->
<!--									</li>-->
<!--									<li class="swiper-slide" :class="{ 'active': (params.STATUS === 'shop') }">-->
<!--										<a href="javascript:;" @click="setStatus('shop')">상품</a>-->
<!--									</li>-->
<!--								</ul>-->
<!--							</div>-->

<!--							<div class="search-result-form">-->
							<div class="search">
								<p class="total">총 <span>{{ eduCount }}</span>개의 게시물이 있습니다.</p>
								<div class="search-form">
									<input class="inp-search" id="" name="" type="text" placeholder="검색어를 입력하세요" v-model="params.searchText">
									<button type="submit" class="btn-search"></button>
								</div>
							</div>


							<edu-sorter @doSort="doSort"></edu-sorter>


						</form>
					</div>

					<edu-list v-if="!$options.filters.isEmpty( params.WISH_LIKE )" :edu-list="eduList"></edu-list>
					<edu-mine-list v-else :edu-list="eduList"></edu-mine-list>

					<!-- 버튼 -->
					<div class="btn-area" v-if="eduList.length < eduCount">
						<a href="javascript:;" class="btn-loadmore" @click="doLoadMore">LOAD MORE</a>
					</div>

				</template>

			</div>
		</div>
		<!--//content -->

	</div>

</template>

<script>
import EduList from "@/components/educations/main/eduList";
import EduLearning from "@/components/educations/main/eduLearning";
import EduMineList from "@/components/educations/mine/eduMineList";
import EduSorter from "@/components/educations/eduSorter";
import $ from "jquery";
import Swiper from "../../../public/ssflex/assets/js/swiper.min";

export default {
	name: "appMyEducations",
	components: {EduSorter, EduList, EduMineList, EduLearning },
	data() {

		/**
		 * mode : list, learn
		 * @type {string|string}
		 */
		var mode = this.webUtils.getParameter("mode")
		mode = (mode === '') ? "list" : mode;

		/**
		 * emIdx
		 * @type {number|string|string}
		 */
		var emIdx = this.webUtils.getParameterInt("emIdx");
		emIdx = ( emIdx > 0 ) ? emIdx : 0;

		var params = new this.pageUtils.Params();
		params.size = 8;
		// if( params.WISH_LIKE !== null){
		// 	params.STATUS = ( this.webUtils.getParameter("STATUS") === "" ) ? "edu" : this.webUtils.getParameter("STATUS");
		// }else{
			params.STATUS = ( this.webUtils.getParameter("STATUS") === "" ) ? "all" : this.webUtils.getParameter("STATUS");
		// }

		if ( !this.stringUtils.isEmpty( this.$route.query.cateCode ) ) {
			params.cateCode = this.$route.query.cateCode
		} else {
			params.cateCode = this.$route.params.cateCode
		}

		return {
			PAGE_TITLE: "학습현황",
			mode,
			emIdx,
			cateCodeVO: {},
			coAccountVO: {},

			params,

			eduList: [],
			eduCount: 0,

			rateCode: 0,
		}
	},
	created() {

		this.requireLogin(this, false)

		this.$eventBus.$on("goLearning", (_emIdx) => {
			this.goLearning( _emIdx );
		});

		$(".tab").ready(() => {
			this.$nextTick(() => {
				$(".tab").each(function () {
					new Swiper($(this), {
						slidesPerView: "auto",
						spaceBetween: 24,
						freeMode: true,
					})
				})
			})
		})

	},
	async mounted() {

		this.getMainList();
	},
	methods: {



		getMainList () {

			const self = this
			let URL = this.APIs.EDU_MINE + "/";

			let temp = this.params
			switch (temp.STATUS) {
				case "all":
					temp.isRequest = true;
					delete temp.isComplete;
					break;
				case "req":
					temp.isRequest = true;
					temp.isComplete = false;
					break;
				case "com":
					temp.isRequest = true;
					temp.isComplete = true;
					break;
				default:
					this.PAGE_TITLE = "학습현황";
					break;
			}

			if ( this.$route.params.WISH_LIKE != null ) {

				temp.WISH_LIKE = this.$route.params.WISH_LIKE
				URL += "getEduWishLikeList";

				switch (this.$route.params.WISH_LIKE) {
					case "wish":
						this.PAGE_TITLE = "관심교육";
						break;
					case "like":
						this.PAGE_TITLE = "좋아요";
						break;
					default:
						this.PAGE_TITLE = "학습현황";
						break;
				}
			}

			//temp.sort = "studentVO.requestDate,DESC";

			this.coAccountVO = this.getSessionProc();

			this.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.get( this, URL, temp, (res) => {
				this.$eventBus.$emit("doneProgress", 1)

				const result = res.data
				if ( result.status === "ok" ) {

					console.log( result )
					// this.eduList.push(...result.list)
					self.eduList = result.list
					self.eduCount = result.count

					let prevEmIdx = localStorage.getItem("emIdx")
					if (prevEmIdx) {
						$('.list-content').ready(() => {
							this.$nextTick(() => {
								this.webUtils.scrollTo("#item-" + prevEmIdx).then(() => {
									localStorage.removeItem("emIdx")
								})
							})
						})
					}

					self.eduList.forEach(eduMain => {

						eduMain.allContentCnt = 0;
						eduMain.completeContentCnt = 0;
						eduMain.answerList = []

						eduMain.contentList.forEach(content => {

							if ( content.contentType === 'tst' ) {
								eduMain.isTest = true;
								eduMain.isTestTxt = "있음";
								eduMain.allContentCnt += content.qstTstList.length;
							} else if ( content.contentType === 'mov' ) {
								eduMain.playMinutes += content.qstMovVO.playMinutes;
								eduMain.allContentCnt += content.qstMovVO.playMinutes;
							} else if ( content.contentType === 'file' ) {
								eduMain.allContentCnt += content.qstFileVO.fileList.length;
							}
						})

						var index = 0;
						eduMain.studentVO.answerList.forEach(ans => {

							if ( ans.contentType === 'tst' ) {
								eduMain.completeContentCnt += ans.tstSolveCount;
							} else if ( ans.contentType === 'mov' && eduMain.contentList[index].qstMovVO != null ) {

								//eduMain.completeContentCnt++;
								if ( ans.isComplete || Math.floor(ans.ansMovVO.currentTimes / 60) >= eduMain.contentList[index].qstMovVO.playMinutes  ) {
									/**
									 * 영상이수완료 or 플레이시간이 필수플레이 시간보다 많을 경우
									 */
									eduMain.completeContentCnt += eduMain.contentList[index].qstMovVO.playMinutes
								} else {
									/**
									 * 플레이 시간을 분단위로 변경
									 * @type {number}
									 */
									eduMain.completeContentCnt += Math.floor(ans.ansMovVO.currentTimes / 60);
								}

							} else if ( ans.contentType === 'file' && eduMain.contentList[index].qstFileVO != null ) {

								if ( ans.isComplete ) {
									eduMain.completeContentCnt += eduMain.contentList[index].qstFileVO.fileList.length;
								} else {
									eduMain.completeContentCnt += ans.fileDownloadCount;
								}
							}

							index++;
						})
						//eduMain.answerList = eduMain.studentVO.answerList

					})


				} else {
					console.log( result.msg )
				}

			})

		},


		doLoadMore() {

			this.params.page++;
			this.params.scrollTop = false;
			this.pageUtils.routerPush( this, this.params )
			//this.getMainList();
		},


		setCateCode( _cateCode ) {

			// 빈코드가 올 경우 기본 코드 전송
			if ( _cateCode == null || _cateCode === "" ) {
				_cateCode = this.cateCode
			}

			this.params.page = 0
			this.params.cateCode = _cateCode;
			this.params.searchText = "";

			this.pageUtils.routerPush( this, this.params )
			//this.getMainList();
		},


		setStatus ( _status ) {

			this.params.STATUS = _status;
			this.webUtils.goTo(this, this.params)
			//this.getMainList();
		},


		doSearch(e) {

			e.preventDefault()
			this.params.page = 0
			//this.params.cateCode = "";
			this.pageUtils.routerPush( this, this.params )
			//this.getMainList();
		},



		doSort ( _sort ) {
			this.params.sort = _sort;
			this.pageUtils.routerPush( this, this.params )
			//this.getMainList();
		},



		goLearning(_emIdx) {

			this.mode = "learn"
			this.emIdx = _emIdx
			var temp = {
				mode: this.mode,
				emIdx: _emIdx,
				page: this.params.page,
				sort: this.params.sort,
				searchText: this.params.searchText
			}
			this.webUtils.goTo(this, temp, true, false, () => {
				this.webUtils.scrollTo('.content');
			})
		},

		goList() {
			localStorage.setItem("emIdx", this.webUtils.getParameter("emIdx"))
			this.webUtils.goTo(this, { page: this.params.page, sort: this.params.sort, searchText: this.params.searchText })
		}

	},
}
</script>

<style scoped>

</style>
